import { render } from "./RegisterSuccess.vue?vue&type=template&id=8a43b766"
import script from "./RegisterSuccess.vue?vue&type=script&lang=js"
export * from "./RegisterSuccess.vue?vue&type=script&lang=js"
script.render = render

export default script